<template>
  <b-form-select
    v-bind="$attrs"
    :options="options"
    @change="handleChange"
    v-model="selectedCommissionStatus"
    style="min-width: 220px;"
    class="form-control"
  >
    <template #first>
      <b-form-select-option :value="null">
        Status da Comissão
      </b-form-select-option>
    </template>
  </b-form-select>
</template>

<script>
import { COMMISSION_STATUS } from '../constants';

export default {
  props: {
    value: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      selectedCommissionStatus: this.value,
      options: [
        {
          value: 'TO_BE_PAID',
          text: COMMISSION_STATUS.TO_BE_PAID,
        },
        {
          value: 'INVOICE_CREATED',
          text: COMMISSION_STATUS.INVOICE_CREATED,
        },
        {
          value: 'PAID',
          text: COMMISSION_STATUS.PAID,
        },
      ],
    };
  },
  methods: {
    handleChange() {
      this.$emit('input', this.selectedCommissionStatus);
    },
  },
};
</script>
